import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./pages.css";

export default function BlogPage() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://nastyauthenticbackend.onrender.com/api/blogs")
      .then((r) => r.json())
      .then((data) => {
        if (data.success === false) {
          alert("Error fetching blogs.");
        }
        setBlogs(data.blogs);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error occured in fetching blogs", err);
      });
  }, []);
  console.log(blogs);
  return (
    <div className="page">
      <p className="section-title">JOURNAL</p>
      <h1 className="big-title">THE BLOG</h1>

      {loading ? (
        <p
          style={{ textAlign: "center", letterSpacing: "0.1em", fontSize: 12 }}
        >
          LOADING...
        </p>
      ) : (
        <div className="blog-grid">
          {blogs.map((b) => (
            <div
              key={b._id}
              className="blog-card"
              onClick={() =>
                navigate(`/blog/${b.slug}`, { state: { blog: b } })
              }
              style={{ cursor: "pointer" }}
            >
              <img src={b.image} className="blog-img" alt="Blog" />
              <div className="blog-body">
                <div
                  style={{
                    display: "flex",
                    gap: 6,
                    flexWrap: "wrap",
                    marginBottom: 8,
                  }}
                >
                  {b.tags?.slice(0, 3).map((t) => (
                    <span
                      key={t}
                      style={{
                        fontSize: 9,
                        letterSpacing: "0.1em",
                        background: "#111",
                        color: "#fff",
                        padding: "2px 8px",
                      }}
                    >
                      {t.toUpperCase()}
                    </span>
                  ))}
                </div>
                <p className="blog-date">
                  {new Date(b.createdAt).toDateString()}
                </p>
                <h3 className="blog-title">{b.title}</h3>
                <p className="blog-excerpt">{b.meta?.description}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
